import { render } from "./OrgExcecutiveReport.vue?vue&type=template&id=11b53c56&scoped=true"
import script from "./OrgExcecutiveReport.vue?vue&type=script&lang=js"
export * from "./OrgExcecutiveReport.vue?vue&type=script&lang=js"

import "./OrgExcecutiveReport.vue?vue&type=style&index=0&id=11b53c56&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11b53c56"]])

export default __exports__